module.exports = __webpack_public_path__ + "img/bottom_transparent.298b1a5c.png";